export const API_URL = 'https://ipqf.develop.ares.empeek.net/api';
export const API_AUTHORIZATION_URL = `${API_URL}/Token`;
